import * as ActionTypes from "../ActionTypes";
const initState = {
  examResults: "",
};
const ExamResultsReducer = (state = initState, action) => {
  switch (action.type) {
    case ActionTypes.LOADING:
      return {
        ...state,
        examResults: "loading...",
      };
    case ActionTypes.LOAD_EXAMRESULTS_SUCCESS:
      return {
        ...state,
        examResults: action.res,
      };
    case ActionTypes.LOAD_EXAMRESULTS_ERROR:
      return {
        ...state,
        examResults: action.res,
      };
    case ActionTypes.CODE_ERROR:
      return {
        ...state,
        examResults:
          "There seems to be a problem, please refresh your browser",
      };
    default:
      return state;
  }
};
export default ExamResultsReducer;

